/**
 * Extracts the portal name from metadata object
 * @param metadata - The metadata object that may contain portal_name
 * @returns The portal name if found, otherwise defaults to "CMM"
 */
export const getPortalNameFromMetadata = (metadata: unknown): string => {
  const portal =
    typeof metadata === "object" &&
    metadata !== null &&
    "portal_name" in metadata
      ? ((metadata as Record<string, any>).portal_name ?? "CMM")
      : "CMM";

  return portal;
};
